export const base_path = "/app";
export const image_path ='/app/'

